
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.333 1.74L10.258.668 6 4.926 1.74.666.666 1.742 4.926 6l-4.26 4.259 1.074 1.074L6 7.074l4.258 4.26 1.075-1.075L7.073 6l4.26-4.26z","fill":"currentColor"}})])
          )
        }
      }
    